"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHEventHandler = void 0;
class KHEvent {
    constructor(name) {
        this.name = name;
        this.callbacks = [];
    }
    registerCallback(cb) {
        this.callbacks.push(cb);
    }
    unregisterCallback(cb) {
        let idx = this.callbacks.indexOf(cb);
        if (idx < 0)
            return;
        this.callbacks.splice(idx, 1);
    }
    emitEvent(data) {
        this.callbacks.forEach(function (callback) {
            callback(data);
        });
    }
}
class KHEventHandler {
    constructor() {
        this.events = new Map();
    }
    ensureEvent(name) {
        let val = this.events.get(name);
        if (!val) {
            val = new KHEvent(name);
            this.events.set(name, val);
        }
        return val;
    }
    emitEvent(name, args) {
        this.ensureEvent(name).emitEvent(args);
    }
    registerCallback(name, listener) {
        this.ensureEvent(name).registerCallback(listener);
    }
    unregisterCallback(name, cb) {
        this.ensureEvent(name).unregisterCallback(cb);
    }
}
exports.KHEventHandler = KHEventHandler;
